import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import CTAFooter from "@/components/CTAFooter";

export default function Landing() {
  return (
    <main data-testid="landing-main" className="relative">
      <Hero />

      {/* signature slow editorial marquee */}
      <Marquee
        items={["BAT", "RAT", "HAT", "RAT", "FAT", "$USDC", "MEME", "ARC"]}
        bg="var(--ink)"
        color="var(--cream)"
        accent="var(--meme-yellow)"
        slow
      />

      <Manifesto />

      {/* second, small marquee — reversed, pink */}
      <Marquee
        items={["squeak", "buy", "hodl", "fly", "$usdc", "beanie gang"]}
        bg="var(--meme-pink)"
        color="var(--ink)"
        accent="var(--usdc-blue)"
        reverse
        slow={false}
        size="text-[9vw] md:text-[6vw]"
      />

      <CTAFooter />
    </main>
  );
}
